import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { EmtTheme } from "../types";

type EmtCardLoaderProps = {
  /**
   * @default 'default'
   */
  variant?: "inline" | "default";
};

const DefaultPulse = styled(Stack)(() => ({
  background: "white",
  borderRadius: "18px",
  paddingBottom: "5px",
  width: "100%",
}));

const InlinePulse = styled(Box)(({ theme }: { theme?: EmtTheme }) => ({
  display: "flex",
  width: "100%",
  alignItems: "center",
  background: "white",
  borderRadius: "18px",
  padding: "5px",
  paddingLeft: "10px",
  border: `1px solid ${theme?.palette.greyGradient[100]}`,
}));

export function EmtCardLoader(props: EmtCardLoaderProps) {
  const { variant = "default" } = props;
  return variant === "default" ? (
    <DefaultPulse>
      <Skeleton
        variant="rectangular"
        width={"100%"}
        height={200}
        sx={{ borderRadius: "18px" }}
      />
      <Box sx={{ padding: "5px" }}>
        <Box
          sx={{
            display: "flex",
            gap: "3px",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Skeleton variant="text" width="120px" />
          </Box>
          <Box>
            <Skeleton variant="circular" width={30} height={30} />
          </Box>
        </Box>
        <Skeleton variant="text" sx={{ marginTop: "2px" }} />
        <Box
          sx={{
            display: "flex",
            gap: "3px",
            maxWidth: "170px",
            marginTop: "5px",
          }}
        >
          <Skeleton
            variant="rectangular"
            width={"100%"}
            height={28}
            sx={{ borderRadius: "18px" }}
          />
          <Skeleton
            variant="rectangular"
            width={"100%"}
            height={28}
            sx={{ borderRadius: "18px" }}
          />
        </Box>
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={32}
          sx={{ borderRadius: "18px", marginTop: "8px" }}
        />
      </Box>
    </DefaultPulse>
  ) : (
    <InlinePulse>
      <Skeleton
        variant="rectangular"
        width={100}
        height={100}
        sx={{ borderRadius: "18px" }}
      />
      <Box sx={{ padding: "5px" }}>
        <Box
          sx={{
            display: "flex",
            gap: "3px",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Skeleton variant="text" width="140px" />
          </Box>
          <Box>
            <Skeleton variant="circular" width={20} height={20} />
          </Box>
        </Box>
        <Skeleton width={110} variant="text" sx={{ marginTop: "2px" }} />
        <Box
          sx={{
            display: "flex",
            gap: "3px",
            maxWidth: "130px",
            marginTop: "5px",
          }}
        >
          <Skeleton
            variant="rectangular"
            width={"100%"}
            height={20}
            sx={{ borderRadius: "18px" }}
          />
          <Skeleton
            variant="rectangular"
            width={"100%"}
            height={20}
            sx={{ borderRadius: "18px" }}
          />
        </Box>
        <Skeleton
          variant="rectangular"
          width={"50%"}
          height={26}
          sx={{ borderRadius: "10px", marginTop: "8px" }}
        />
      </Box>
    </InlinePulse>
  );
}
